import React, {useEffect, useState} from "react";
import {Button, Modal} from "antd";
import useUserContext from "../../hooks/useUserContext";
import {BigInput} from "../forms/bigInput/BigInput";
import PaypalPayment from "./PaypalPayment";
import useAppContext from "../../hooks/useAppContext";
import PricingPlanSelection from "../pricingPlanSelection/PricingPlanSelection";

interface PricingPlanModalProps {
    isOpen: boolean;
    toggle: () => void;
}

const PricingPlanModal = ({ isOpen, toggle }: PricingPlanModalProps) => {
    return <div className="paymentModal">
        <Modal open={isOpen} className="add-funds-modal" onCancel={toggle} width="90%" footer={() => null} zIndex={11000}>
            <PricingPlanSelection isInClosedModal />
        </Modal>
    </div>
}

export default PricingPlanModal;
